import { Text, View } from "react-native";

import { cn } from "@/lib/ui/cn";
import { GemMark } from "./GemMark";

export type LogoProps = {
  /** `"horizontal"` sets the wordmark beside the mark; `"stacked"` sets it beneath. */
  variant?: "horizontal" | "stacked";
  /** The mark's height; the wordmark and the lockup spacing are derived from it. */
  size?: number;
  /** Pins the full lockup to one ink on a fixed brand canvas, such as an exported story. */
  color?: string;
  /** Pass `false` for fixed exported artwork, which must not reflow with the text-size setting. */
  allowFontScaling?: boolean;
};

/**
 * Brand lockup: the gem mark and the lowercase `trovie` wordmark in the title face.
 *
 * The mark is wider than it is tall (189:148), so `size` is its height and everything else follows
 * from it: the wordmark is `round(size * 0.7)` and the gap is `round(size / 4)`, which is 8 at the
 * default size 32 (DESIGN.md §7). The gap is derived rather than a Tailwind step so that a call site
 * laying the lockup out in its own unit space (the shared QR card's fixed 1080x1920 canvas) does
 * not get one measurement in device points while the rest scale with `size`.
 */
export function Logo({
  variant = "horizontal",
  size = 32,
  color,
  allowFontScaling,
}: LogoProps) {
  const stacked = variant === "stacked";
  return (
    <View
      className={cn("items-center", stacked ? "flex-col" : "flex-row")}
      style={{ gap: Math.round(size / 4) }}
    >
      <View aria-hidden>
        <GemMark size={size} color={color} />
      </View>
      <Text
        allowFontScaling={allowFontScaling}
        className="font-title text-foreground"
        style={color
          ? { color, fontSize: Math.round(size * 0.7) }
          : { fontSize: Math.round(size * 0.7) }}
      >
        trovie
      </Text>
    </View>
  );
}
